import React from 'react'
import { observer } from 'mobx-react'
import { RestoreToWorkspaceViewModel } from './RestoreToWorkspaceViewModel'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from '../../../components/ModalSheet'
import Button from '../../../components/Button'
import { pluralize } from '../../../utils/pluralization-util'

interface Props {
  vm: RestoreToWorkspaceViewModel
}

const RestoreToWorkspaceDialog = observer(({ vm }: Props) => {
  return (
    <ModalSheet showing={vm.showing} onRequestClose={vm.close}>
      <ModalSheetHeader withCloseButton />

      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetContentIllustration
            src={require('assets/images/img_add-to-calendar.svg')}
            alt="Illustration of a user being restored to the workspace"
          />

          <ModalSheetContentTitle>Restore to workspace</ModalSheetContentTitle>

          <ModalSheetContentDescription>
            You are about to restore{' '}
            <b>
              {vm.selectedUser
                ? vm.selectedUser.displayName
                : `${vm.selectedUserIds.length} ${pluralize('user', vm.selectedUserIds.length)}`}
            </b>{' '}
            to <b>{vm.workspace.name}</b>
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>

      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button type="default" onClick={vm.close}>
            Close
          </Button>
          <Button
            type="success"
            data-test="user-management-restore-to-workspace-button"
            onClick={vm.restore}
            disabled={vm.restore.pending}
            loading={vm.restore.pending}
          >
            {vm.selectedUserIds.length > 1
              ? 'Restore selected'
              : 'Restore to workspace'}
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})

export default RestoreToWorkspaceDialog
